import React, { useEffect, useState } from "react";
import { getOfflineData } from "../../utils/offline-services";
import ShowUsers from "../admin-screen";
import { Navigate } from "react-router-dom";
import AllowedApps from "../allowed-apps";
import { ResetPasswordModal } from "../custom-modals/reset-password.modal";
import { ChangePasswordModal } from "../change-password-modal";

const Home = () => {
  const userRole = getOfflineData("user")?.role;
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);

  useEffect(() => {
    const user = getOfflineData("user");
    // Microsoft SSO users have no local password to reset.
    if (user?.changePasswordOnLogin && user?.authProvider !== "microsoft") {
      setShowChangePasswordModal(true);
    }
  }, []);

  return (
    <div>
      {userRole === "admin" ? <ShowUsers /> : <AllowedApps />}
      {/* {userRole !== "admin" && <AllowedApps />} */}

      {!userRole && <Navigate to="/login" />}
      <ResetPasswordModal
        showChangePasswordModal={showResetPasswordModal}
        setShowChangePasswordModal={setShowResetPasswordModal}
      />
      <ChangePasswordModal
        showChangePasswordModal={showChangePasswordModal}
        setShowChangePasswordModal={setShowChangePasswordModal}
      />
    </div>
  );
};

export default Home;
